<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import qrIcon from '../assets/images/qr-code.svg'

const { t } = useI18n()
const version = __APP_VERSION__
</script>

<template>
  <div class="content">
    <div class="container">
      <h1 v-html="t('titleHome', { version })"></h1>
      <p style="text-transform: uppercase">{{ t('welcome') }}</p>
      <p id="qr-code"></p>
      <p v-html="t('qrInfo', { qrIcon })"></p>
      <p>
        <img src="/map.png" :alt="t('mapAlt')" style="max-width: 100%" />
      </p>
      <p>{{ t('homeText') }}</p>
    </div>
  </div>
</template>

<style scoped>
h1 {
  text-transform: uppercase;
}
</style>
